import { Role } from "../../../helpers/role";
export const AcquisitionMenu = [
  {
    title: "Home",
    icon: "mdi-view-dashboard",
    to: "",
    code: "dashboard",
    role: [Role.Acquisition],
  },

  // {
  //   title: "Home",
  //   icon: "mdi-view-dashboard",
  //   to: "dealer-home",
  //   code: "dealer-home",
  //   role: [Role.Acquisition],
  // },

  {
    title: "Sign-ups",
    icon: "mdi-clipboard-check",
    code: "sign-ups",
    role: [Role.Acquisition],
    submenu: [
      {
        title: "No Nap",
        icon: "mdi-checkbox-blank-off-outline",
        to: "no-nap",
        code: "no-nap",
        role: [Role.Acquisition],
      },

      {
        title: "For Installation",
        icon: "",
        to: "for-installation",
        code: "for-installation",
        badge: {
          status: true,
          value: "forInstallation",
        },
        role: [Role.Acquisition],
      },
      {
        title: "Pay Later",
        icon: "",
        to: "partial-pay-later",
        code: "partial-pay-later",
        badge: {
          status: true,
          value: "payLater",
        },
        role: [Role.Acquisition],
      },
    ],
  },

  {
    title: "Activations",
    icon: "mdi-archive-check",
    to: "",
    code: "activated-list",
    role: [Role.Acquisition],
    submenu: [
      {
        title: "Activation per Area",
        icon: "",
        to: "activation-per-area",
        code: "activated-list",
      },
      {
        title: "Subscriber Activation",
        icon: "",
        to: "subscriber-activation",
        code: "activated-list",
      },
    ],
  },

  {
    title: "Subscribers",
    icon: "mdi-playlist-check",
    to: "subscribers",
    code: "subscribers",
    role: [Role.Acquisition],
  },

  {
    title: "Dealers",
    icon: "mdi-storefront",
    to: "dealers",
    code: "dealers",
    role: [Role.Acquisition],
  },

  {
    title: "Retailers",
    icon: "mdi-store-marker",
    to: "retailers",
    code: "retailers",
    role: [Role.Acquisition],
  },

  {
    title: "Sales Agent",
    icon: "mdi-face-agent",
    to: "sales-agent",
    code: "sales-agent",
    role: [Role.Acquisition],
  },

  {
    title: "Sales Reports",
    icon: "mdi-chart-line",
    role: [Role.Acquisition],
    code: "sales-reports",
    submenu: [
      {
        title: "Monthly",
        icon: "mdi-calendar-month-outline",
        to: "monthly-sales-report",
        code: "monthly-sales-report",
      },
      {
        title: "Daily",
        icon: "mdi-calendar-outline",
        to: "daily-sales-report",
        code: "daily-sales-report",
      },

      {
        title: "SKU",
        icon: "mdi-identifier",
        to: "sku-sales-report",
        code: "sku-sales-report",
      },
    ],
  },

  {
    title: "JO List",
    icon: "mdi-clipboard-list-outline",
    to: "jo-list",
    code: "jo-list",
    role: [Role.Acquisition],
  },

  {
    title: "JO Approved",
    icon: "mdi-playlist-check",
    to: "jo-approved",
    code: "jo-list",
    role: [Role.Acquisition],
  },

  {
    title: "JO Created",
    icon: "mdi-playlist-check",
    to: "jo-created",
    code: "jo-list",
    role: [Role.Acquisition],
  },

  {
    title: "Prepaid Fiber Customer",
    icon: "mdi-account-multiple-outline",
    to: "prepaid-fiber-customer",
    code: "jo-list",
    role: [Role.Acquisition],
  },

  {
    title: "Port Reservation",
    icon: "mdi-table-arrow-left",
    to: "port-reservation",
    code: "jo-list",
    role: [Role.Acquisition],
  },

  {
    title: "Home",
    icon: "mdi-view-dashboard",
    to: "ibas-home",
    code: "ibas-home",
    role: [Role.Acquisition],
  },

  {
    title: "For Installation",
    icon: "mdi-home-automation",
    to: "ibas-for-installation",
    code: "ibas-for-installation",
    role: [Role.Acquisition],
  },

  {
    title: "Distributor Activation",
    icon: "mdi-domain",
    to: "distributor-activation",
    code: "distributor-activation",
    role: [Role.Acquisition],
  },

  {
    title: "COD Home",
    icon: "mdi-home",
    to: "online-home",
    code: "online-home",
    role: [Role.Acquisition],
  },

  {
    title: "Online Application",
    icon: "mdi-web-check",
    code: "cod-main",
    role: [Role.Acquisition],
    submenu: [
      {
        title: "For Confirmation",
        icon: "",
        to: "online-for-confirmation",
        code: "online-for-confirmation",
        role: [Role.Acquisition],
        badge: {
          param: "cod",
          status: true,
          value: "COD_FOR_CONFIRMATION",
        },
      },

      {
        title: "For Installation (COD)",
        icon: "",
        to: "online-for-installation",
        code: "online-for-installation",
        badge: {
          param: "cod",
          status: true,
          value: "COD_FOR_INSTALLATION",
        },
        // badge: {
        //   status: true,
        //   value: "forInstallation",
        // },
        role: [Role.Acquisition],
      },
      // {
      //   title: "For Installation (Paid Online)",
      //   icon: "",
      //   to: "online-for-installation-paid",
      //   code: "online-for-installation",
      //   // badge: {
      //   //   status: true,
      //   //   value: "forInstallation",
      //   // },
      //   role: [Role.Acquisition],
      // },
      {
        title: "Past Due",
        icon: "",
        to: "online-past-due",
        code: "online-past-due",
        badge: {
          param: "cod",
          status: true,
          value: "COD_PAST_DUE",
        },
        role: [Role.Acquisition],
      },

      {
        title: "Installed",
        icon: "",
        to: "online-installed",
        code: "online-past-due",
        badge: {
          param: "cod",
          status: true,
          value: "COD_INSTALLED",
        },
        role: [Role.Acquisition],
      },

      {
        title: "Cancelled",
        icon: "",
        to: "online-cancelled",
        code: "online-past-due",
        // code: "ledger",
        badge: {
          param: "cod",
          status: true,
          value: "COD_CANCELLED",
        },
        role: [Role.Acquisition],
      },
    ],
  },

  {
    title: "Distributor Sales",
    icon: "mdi-chart-areaspline",
    to: "distributor-sales",
    code: "distributor-activation",
    role: [Role.Acquisition],
  },

  {
    title: "JO Number List",
    icon: "mdi-clipboard-list-outline",
    to: "jo-number-list",
    code: "jo-number-list",
    // code: "online-past-due",
    role: [Role.Acquisition],
  },

];
